module.exports = __webpack_public_path__ + "src/modules/home/training/images/1702.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1702.png
// module id = 785
// module chunks = 0